import { List } from 'antd';
import Ascensor from 'components/Ascensor';
import useTenantFlags from 'hooks/useTenantFlags';
import React from 'react';

const AscensoresList = (props) => {
  const { readOnly } = useTenantFlags();
  const {
    ascensores,
    openEditAscensor,
    isLoading,
    openDeleteAscensor,
    openDuplicateAscensor,
    noActions = false,
    extraItem = null,
  } = props;
  // En solo-lectura ocultamos las acciones de escritura (editar/borrar/duplicar)
  // del item, reutilizando el prop `noActions` que ya las suprime.
  const hideActions = noActions || readOnly;
  return (
    <List
      loading={isLoading}
      grid={{
        gutter: 12,
        xs: 1,
        sm: 2,
        md: 2,
        lg: 2,
        xl: 2,
        xxl: 2,
      }}
      pagination={{
        align: 'end',
        position: 'bottom',
        pageSize: 8,
      }}
      dataSource={ascensores}
      renderItem={(ascensor) => (
        <Ascensor
          noActions={hideActions}
          key={ascensor.id}
          data={ascensor}
          openEditAscensor={readOnly ? undefined : openEditAscensor}
          openDeleteAscensor={readOnly ? undefined : openDeleteAscensor}
          openDuplicateAscensor={readOnly ? undefined : openDuplicateAscensor}
          extra={extraItem}
        />
      )}
    />
  );
};

export default AscensoresList;
